import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthServiceZ } from './auth-service.service';
import { SharedService } from './../shared/shared.service';

@Injectable({
  providedIn: 'root',
})
export class IntiGoAuthGuardService implements CanActivate {
  constructor(
    public auth: AuthServiceZ,
    public router: Router,
    public authService: AuthServiceZ,
    public sharedService: SharedService
  ) {}
  DefaultNonAuthorisedUrl = '/auth/login/admin';

  // This should be changed to work only on new login,
  // Otherwise the admin should be returned to a 403 page when trying to access
  // unauthorised pages.
  resolveRedirectUrl(userServices) {
    
    if (userServices.includes('2') || userServices.includes('1')) {
      return '/livraison';
    }
    if (userServices.includes('5')) {
      return '/users';
    }
    if (userServices.includes('6')) {
      return '/finance/encaissement';
    }
    if (userServices.includes('7')) {
      return '/mobileApp/appVersion';
    }

    if (userServices.includes('9')) {
      return '/finance/driver';
    }
    return this.DefaultNonAuthorisedUrl;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.auth.isAuthenticated()) {

        this.router.navigate(['/auth/login/admin']);
        resolve(false);
      }
      if (
        this.auth.credentials?.user?.userType != 'User' &&
        this.auth.credentials?.user?.userType != 'Driver'
      ) {
        const userServices = this.auth.credentials.user.services;
        if (
          ((state.url.toLowerCase().includes('livraison') &&
            !state.url.toLowerCase().includes('finance')) ||
            state.url.toLowerCase().includes('express') ||
            state.url.toLowerCase().includes('delivery') ||
            state.url.toLowerCase().includes('pickups') ||
            state.url.toLowerCase().includes('partner')) &&
          userServices.includes('2')
        ) {
          resolve(true);
        } else if (
          state.url.toLowerCase().includes('conciergerie') &&
          userServices.includes('1')
        ) {
          resolve(true);
        } else if (
          state.url.toLowerCase().includes('mobileapp') &&
          userServices.includes('7')
        ) {
          resolve(true);
        } else if (
          (state.url.toLowerCase().includes('users') ||
            state.url.toLowerCase().includes('params') ||
            state.url.includes('payment')) &&
          userServices.includes('5')
        ) {
          resolve(true);
        } else if (
          state.url.toLowerCase().includes('finance') &&
          userServices.includes('6')
        ) {
          resolve(true);
        } else if (
          state.url.toLowerCase().includes('finance/driver') &&
          userServices.includes('9')
        ) {
          resolve(true);
        } else {
          this.router.navigate([this.resolveRedirectUrl(userServices)]);
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  }
}
